<template>
  <header
    class="fixed top-0 inset-x-0 z-50 h-20 flex items-center justify-between px-8 transition-all duration-500"
    :class="{ 'h-16 bg-[#0f0f11]/60': isScrolled }"
  >
    <div class="flex-1 flex items-center">
      <NuxtLink
        to="/explore"
        class="transition-transform duration-300 hover:scale-105 active:scale-95"
      >
        <PebbleAppHomeLogo class="h-8 w-auto" />
      </NuxtLink>
    </div>

    <nav
      class="hidden md:flex items-center gap-1 p-1 bg-white/3 border border-white/5 rounded-full backdrop-blur-md"
    >
      <NuxtLink
        v-for="link in navLinks"
        :key="link.name"
        :to="link.href"
        class="relative flex items-center gap-2.5 px-5 py-2.5 rounded-full text-[13px] font-medium tracking-wide transition-all duration-300 group overflow-hidden"
        active-class="nav-link-active"
      >
        <component
          :is="link.icon"
          :size="18"
          :stroke-width="2"
          class="z-10 transition-transform group-hover:scale-110 text-white/40 group-hover:text-white"
        />

        <span
          class="z-10 hidden lg:block tracking-wider text-white/40 group-hover:text-white"
        >
          {{ link.name }}
        </span>

        <div
          class="active-indicator absolute inset-0 bg-white/5 border border-white/10 rounded-full opacity-0 transition-opacity duration-300"
        />
      </NuxtLink>
    </nav>

    <div class="flex-1 flex justify-end items-center gap-4">
      <PebbleAppLink
        v-if="isAnyCreator"
        type="button"
        variant="outline"
        :leading-icon="SquarePlus"
        :to="getContentCreatorDashboardUrl"
        class="text-white border-white/20 hover:bg-white/10"
      >
        Create
      </PebbleAppLink>
      <div class="relative">
        <PebbleAppUserDropdown />
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from "vue";
import useGetUserRole from "~/utils/auth/useGetUserRole";
import {
  Search,
  Home,
  Film,
  Tv,
  Mic2,
  Video,
  Bell,
  SquarePlus,
} from "lucide-vue-next";
import { storeToRefs } from "#imports";

const config = useRuntimeConfig();
const landingPageUrl = config.public.landingPageUrl;

const navLinks = [
  // { name: "Home", icon: Home, href: landingPageUrl },
  { name: "Premieres", icon: Video, href: "/content/premieres" },
  // { name: "Movies", icon: Film, href: "/content/movies" },
  // { name: "TV Shows", icon: Tv, href: "/content/tv-shows" },
  // { name: "Podcasts", icon: Mic2, href: "/content/podcasts" },
];

const { user } = useAuth();
const { getContentCreatorDashboardUrl } = useGetPebbleCmsUrls();

const isScrolled = ref(false);

const handleScroll = () => {
  isScrolled.value = window.scrollY > 20;
};

const isAnyCreator = computed(() => useGetUserRole(user.value).isAnyCreator());

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style scoped>
/* Base state for icons/text (Muted) */
.nav-link :component,
.nav-link span {
  color: rgba(255, 255, 255, 0.4);
  transition: color 0.3s ease;
}

/* Active State: Force White */
.nav-link-active {
  color: white !important;
}

/* Target icon and text inside the active link */
.nav-link-active svg,
.nav-link-active span {
  color: white !important;
  opacity: 1 !important;
}

.nav-link-active .active-indicator {
  opacity: 1;
}
</style>
